import {
  MAX_UPLOAD_SIZE_BYTE_SIZE,
  UPLOAD_FILE_LIMIT_TOTAL,
  UPLOAD_LIMIT_SIZE_PER_FILE,
} from '@/features/invoices/components/List/Table/Uploader/constant';
import { TUploadFile } from '@/features/invoices/components/List/Table/Uploader/type';
import { useTranslation } from '@/i18n';
import {
  IconCaution,
  IconInfo,
  InlineNotification,
} from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';

export type Props = {
  totalMaxSizeErrVisible: boolean;
  maxFileCountVisible: boolean;
  onMaxFileCountHidden: () => void;
  filesWithError: TUploadFile[];
};

export const InlineNotifications: FC<Props> = memo(
  ({
    totalMaxSizeErrVisible,
    maxFileCountVisible,
    onMaxFileCountHidden,
    filesWithError,
  }) => {
    const { t } = useTranslation();
    return (
      <>
        <InlineNotification
          message={t('received_invoice.uploader.total_max_upload_size', {
            size: MAX_UPLOAD_SIZE_BYTE_SIZE,
          })}
          type='error'
          visible={totalMaxSizeErrVisible}
          visibleClose={false}
          icon={<IconInfo />}
        />
        <InlineNotification
          message={t('received_invoice.uploader.max_upload_size', {
            size: UPLOAD_LIMIT_SIZE_PER_FILE,
          })}
          type='error'
          visible={filesWithError.length > 0}
          visibleClose={false}
          icon={<IconInfo />}
        />
        <InlineNotification
          message={t('received_invoice.uploader.warn_file_count', {
            count: UPLOAD_FILE_LIMIT_TOTAL,
          })}
          type='alert'
          visible={maxFileCountVisible}
          onClick={onMaxFileCountHidden}
          icon={<IconCaution size={18} />}
        />
      </>
    );
  }
);
InlineNotifications.displayName = 'InlineNotifications';
